import { PublicKey } from "@solana/web3.js"
import axios from "axios"
import { EventEmitter } from "eventemitter3"
import { Token, UTLCdnTokenList, UTLSource } from "./types"
import { publicKeysToMap } from "./utils"

export default class Client extends EventEmitter {
  public async fetchMints(cdnUrl: string, mints: PublicKey[]) {
    const tokenlist = await this.getFromTokenList(cdnUrl, mints)

    this.emit("tokens", { tokens: tokenlist, source: UTLSource.API })

    const data = [...tokenlist]

    this.emit("tokens", { tokens: data, source: UTLSource.METADATA })

    return data
  }

  public async getFromTokenList(cdnUrl: string, mints: PublicKey[]) {
    return await this.fetchTokensCdn(cdnUrl, mints)
  }

  public async downloadTokenlist(cdnUrl: string): Promise<UTLCdnTokenList | null> {
    try {
      const { data } = await axios.get<UTLCdnTokenList>(cdnUrl)
      return data
    } catch {
      return null
    }
  }

  public async fetchTokensCdn(cdnUrl: string, mints: PublicKey[]): Promise<Token[]> {
    const tokenlist = await this.downloadTokenlist(cdnUrl)
    const mintsMap = publicKeysToMap(mints)

    return tokenlist?.tokens.filter((token) => mintsMap[token.address]) ?? []
  }
}
